import Phaser from 'phaser';
import { VisualTheme } from './VisualTheme';

export function createProceduralArt(scene: Phaser.Scene) {
  if (scene.textures.exists('fallback.panel')) return;

  const g = scene.make.graphics({ x: 0, y: 0 }, false);
  const point = (x: number, y: number) => new Phaser.Math.Vector2(x, y);

  g.fillStyle(VisualTheme.colors.ink, 1).fillRoundedRect(0, 0, 256, 128, 12);
  g.fillStyle(VisualTheme.colors.panel, 1).fillRoundedRect(5, 5, 246, 118, 10);
  g.lineStyle(3, VisualTheme.colors.gold, 1).strokeRoundedRect(3, 3, 250, 122, 10);
  g.lineStyle(1, VisualTheme.colors.goldBright, 0.3).strokeRoundedRect(11, 11, 234, 106, 7);
  [[16, 16], [240, 16], [16, 112], [240, 112]].forEach(([x, y]) => g.fillStyle(VisualTheme.colors.goldBright, 0.8).fillCircle(x, y, 2.5));
  g.generateTexture('fallback.panel', 256, 128);
  g.clear();

  g.fillStyle(0x081018, 1).fillRect(0, 0, 800, 450);
  g.fillStyle(VisualTheme.colors.ocean, 1).fillRect(0, 175, 800, 275);
  g.fillStyle(0xe2bd69, 0.92).fillCircle(650, 92, 46);
  g.fillStyle(0x1d3340, 1).fillPoints([point(0, 284), point(135, 170), point(235, 282), point(330, 190), point(470, 284)], true);
  g.fillStyle(0x132a31, 1).fillPoints([point(300, 300), point(500, 145), point(690, 302), point(800, 225), point(800, 450), point(300, 450)], true);
  g.fillStyle(0x203f32, 1).fillPoints([point(0, 350), point(95, 318), point(215, 338), point(340, 306), point(480, 342), point(610, 312), point(800, 346), point(800, 450), point(0, 450)], true);
  g.fillStyle(0x0a1215, 1).fillRect(355, 312, 90, 76);
  g.fillTriangle(342, 312, 458, 312, 400, 266);
  g.fillRect(385, 236, 30, 48);
  g.fillTriangle(376, 238, 424, 238, 400, 208);
  g.lineStyle(2, VisualTheme.colors.gold, 0.22);
  for (let i = 0; i < 7; i++) g.lineBetween(0, 360 + i * 13, 800, 340 + i * 15);
  g.generateTexture('fallback.title', 800, 450);
  g.clear();

  g.fillStyle(0x173b4f, 1).fillRect(0, 0, 1250, 680);
  g.lineStyle(1, 0x6d9bad, 0.1);
  for (let x = 25; x < 1250; x += 50) g.lineBetween(x, 0, x, 680);
  for (let y = 25; y < 680; y += 50) g.lineBetween(0, y, 1250, y);
  const java = [point(122, 346), point(210, 316), point(306, 310), point(390, 328), point(486, 316), point(575, 333), point(671, 326), point(767, 342), point(864, 335), point(955, 354), point(1042, 350), point(1128, 375), point(1055, 406), point(962, 400), point(862, 416), point(752, 403), point(660, 417), point(552, 397), point(454, 408), point(350, 390), point(244, 397), point(160, 378)];
  g.fillStyle(0x274833, 1).fillPoints(java, true);
  g.lineStyle(4, 0x8eaa6d, 0.9).strokePoints(java, true);
  g.fillStyle(VisualTheme.colors.goldBright, 0.86);
  [[216, 350], [360, 357], [515, 365], [665, 370], [817, 377], [974, 384], [1090, 388]].forEach(([x, y]) => g.fillCircle(x, y, 5));
  g.generateTexture('fallback.strategic-map', 1250, 680);
  g.clear();

  g.fillStyle(0x101820, 1).fillRect(0, 0, 640, 360);
  g.fillStyle(0x213a45, 1).fillRect(0, 210, 640, 150);
  g.fillStyle(0x9b6840, 0.85).fillCircle(505, 82, 54);
  g.fillStyle(0x263e2d, 1).fillPoints([point(0, 258), point(115, 145), point(230, 260), point(352, 128), point(520, 260), point(640, 172), point(640, 360), point(0, 360)], true);
  g.fillStyle(0x0a1013, 1).fillRect(280, 220, 86, 92);
  g.fillTriangle(263, 221, 383, 221, 323, 174);
  g.lineStyle(3, VisualTheme.colors.gold, 0.92).strokeRect(5, 5, 630, 350);
  g.generateTexture('fallback.art', 640, 360);
  g.clear();

  g.fillStyle(0x0c1219, 1).fillRect(0, 0, 256, 320);
  g.fillStyle(0x26394a, 1).fillRect(10, 10, 236, 300);
  g.fillStyle(0x9b7d58, 1).fillCircle(128, 112, 48);
  g.fillStyle(0x4b3025, 1).fillEllipse(128, 78, 94, 58);
  g.fillStyle(0x314b42, 1).fillEllipse(128, 272, 190, 150);
  g.lineStyle(4, VisualTheme.colors.gold, 1).strokeRect(4, 4, 248, 312);
  g.generateTexture('fallback.portrait', 256, 320);
  g.clear();

  g.fillStyle(VisualTheme.colors.night, 1).fillRect(0, 0, 96, 128);
  g.fillStyle(VisualTheme.colors.crimson, 1).fillTriangle(8, 8, 88, 8, 48, 120);
  g.fillStyle(VisualTheme.colors.goldBright, 1).fillCircle(48, 50, 22);
  g.fillStyle(VisualTheme.colors.night, 1).fillTriangle(34, 62, 62, 62, 48, 28);
  g.lineStyle(3, VisualTheme.colors.goldBright, 1).strokeRect(3, 3, 90, 122);
  g.generateTexture('fallback.banner', 96, 128);
  g.clear();

  g.fillStyle(VisualTheme.colors.ink, 0.96).fillRect(0, 0, 800, 100);
  g.fillStyle(VisualTheme.colors.slate, 0.98).fillRect(6, 6, 788, 88);
  g.lineStyle(3, VisualTheme.colors.gold, 1).strokeRect(2, 2, 796, 96);
  g.generateTexture('fallback.hud', 800, 100);
  g.clear();

  const soldier = (key: string, fill: number, trim: number) => {
    g.fillStyle(0x080b0f, 1).fillCircle(12, 13, 11);
    g.fillStyle(fill, 1).fillCircle(12, 10, 7);
    g.fillTriangle(5, 22, 19, 22, 12, 11);
    g.lineStyle(2, trim, 1).strokeCircle(12, 10, 7);
    g.generateTexture(key, 24, 24);
    g.clear();
  };
  soldier('fallback.soldier.green', VisualTheme.colors.jade, 0xf1d089);
  soldier('fallback.soldier.red', VisualTheme.colors.crimson, 0xf1d089);
  soldier('fallback.soldier.blue', 0x356883, 0xe0ebef);
  soldier('fallback.soldier.gold', 0x9d7839, 0xffe3a0);

  g.fillStyle(0x101820, 1).fillRoundedRect(0, 0, 64, 64, 8);
  g.fillStyle(0x26394a, 1).fillCircle(32, 32, 22);
  g.fillStyle(VisualTheme.colors.goldBright, 1).fillCircle(32, 32, 8);
  g.lineStyle(3, VisualTheme.colors.gold, 1).strokeRoundedRect(2, 2, 60, 60, 8);
  g.generateTexture('fallback.icon', 64, 64);
  g.destroy();
}
